import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのTimeAndAttendanceロゴアイコン
 */
export function ProductLogoMediumTimeAndAttendance({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70949 23.9769C9.90203 24.4349 10.1245 24.8769 10.3746 25.3004C10.5728 25.636 10.4614 26.0689 10.1257 26.2671C9.78998 26.4653 9.35715 26.3539 9.15893 26.0182C8.87656 25.54 8.6254 25.041 8.40804 24.5239C8.19068 24.0069 8.00988 23.4783 7.8658 22.942C7.76465 22.5655 7.98787 22.1783 8.36436 22.0771C8.74086 21.976 9.12807 22.1992 9.22922 22.5757C9.35683 23.0507 9.51695 23.5188 9.70949 23.9769ZM12.7685 29.0521C12.984 28.7272 13.4221 28.6386 13.7469 28.8541C14.1568 29.126 14.5865 29.3713 15.0338 29.5875C15.4811 29.8038 15.9403 29.9882 16.4079 30.1405C16.7786 30.2612 16.9813 30.6595 16.8606 31.0302C16.7398 31.4009 16.3415 31.6036 15.9708 31.4829C15.4428 31.3109 14.9244 31.1027 14.4194 30.8586C13.9144 30.6144 13.4292 30.3375 12.9665 30.0305C12.6416 29.815 12.553 29.3769 12.7685 29.0521ZM8.22368 18.2403C7.84078 18.167 7.58981 17.7972 7.66311 17.4143C7.76753 16.8689 7.90912 16.3285 8.08803 15.7969C8.26694 15.2653 8.48088 14.7492 8.72747 14.2517C8.90058 13.9024 9.32408 13.7595 9.67338 13.9326C10.0227 14.1057 10.1655 14.5292 9.99242 14.8785C9.77403 15.3192 9.58453 15.7763 9.42606 16.2472C9.26758 16.7181 9.14217 17.1967 9.04969 17.6798C8.97639 18.0627 8.60657 18.3136 8.22368 18.2403ZM20.6847 31.3715C20.6315 30.9853 20.9015 30.6291 21.2877 30.576C21.775 30.5089 22.2595 30.4087 22.7381 30.2751C23.2166 30.1415 23.683 29.9762 24.1345 29.7812C24.4924 29.6266 24.9078 29.7914 25.0624 30.1493C25.217 30.5071 25.0522 30.9226 24.6943 31.0772C24.1845 31.2974 23.658 31.484 23.1177 31.6349C22.5775 31.7857 22.0304 31.8988 21.4803 31.9746C21.0941 32.0277 20.7379 31.7577 20.6847 31.3715Z"
        fill="#FCFCFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0512 7.38357C22.9251 7.44377 25.6881 8.50438 27.8641 10.3827C30.0402 12.261 31.493 14.8394 31.9724 17.6737C32.4518 20.508 31.9277 23.4208 30.4904 25.9103C30.2955 26.2479 29.8638 26.3636 29.5262 26.1686C29.1886 25.9737 29.0729 25.542 29.2678 25.2044C30.5408 22.9994 31.005 20.4196 30.5804 17.9092C30.1558 15.3988 28.869 13.115 26.9417 11.4514C25.0143 9.78774 22.5671 8.84835 20.0216 8.79503C17.4761 8.74171 14.9917 9.5778 12.9964 11.1593C12.6909 11.4014 12.2469 11.3501 12.0047 11.0445C11.7626 10.739 11.814 10.295 12.1195 10.0529C14.3723 8.26735 17.1772 7.32337 20.0512 7.38357Z"
        fill="#57D7D9"
      />
      <path
        d="M27.5294 23.3715V27.0589C27.5294 27.3188 27.7401 27.5295 28 27.5295H31.6874C32.1067 27.5295 32.3166 27.0226 32.0202 26.7262L28.3327 23.0387C28.0363 22.7423 27.5294 22.9522 27.5294 23.3715Z"
        fill="#57D7D9"
      />
      <path
        d="M18.353 12.9413C18.353 12.5514 18.669 12.2354 19.0588 12.2354H19.7647C20.1546 12.2354 20.4706 12.5514 20.4706 12.9413V20.2942C20.4706 20.6841 20.1546 21.0001 19.7647 21.0001H19.0588C18.669 21.0001 18.353 20.6841 18.353 20.2942V12.9413Z"
        fill="#FCFCFD"
      />
      <path
        d="M23.9293 23.1801C24.205 23.4557 24.205 23.9027 23.9293 24.1784L23.4302 24.6775C23.1545 24.9531 22.7076 24.9531 22.4319 24.6775L18.5746 20.8202C18.2989 20.5445 18.2989 20.0976 18.5746 19.8219L19.0737 19.3228C19.3494 19.0471 19.7963 19.0471 20.072 19.3228L23.9293 23.1801Z"
        fill="#FCFCFD"
      />
    </svg>
  );
}
